import { z } from "zod";

const vizTypes = ["bar", "line", "area", "pie", "single_value", "table"] as const;

const lookerQuerySchema = z.object({
  model: z.string().min(1),
  explore: z.string().min(1),
  fields: z.array(z.string().min(1)).min(1),
  filters: z.record(z.string()).optional(),
  sorts: z.array(z.string()).optional(),
  limit: z.number().int().positive().max(5000).optional(),
});

const widgetPositionSchema = z.object({
  row: z.number().int().min(0),
  col: z.number().int().min(0).max(11),
  width: z.number().int().min(1).max(12),
  height: z.number().int().min(1).max(12),
});

export const createAgentDashboardSchema = z.object({
  title: z.string().min(1).max(200),
  description: z.string().max(2000).optional().nullable(),
  agentId: z.string().uuid().optional().nullable(),
  layout: z.object({ columns: z.number().int().min(1).max(12).optional() }).optional(),
});

export type CreateAgentDashboard = z.infer<typeof createAgentDashboardSchema>;

export const updateAgentDashboardSchema = createAgentDashboardSchema.partial();
export type UpdateAgentDashboard = z.infer<typeof updateAgentDashboardSchema>;

export const createWidgetSchema = z.object({
  title: z.string().min(1).max(200),
  vizType: z.enum(vizTypes).default("bar"),
  lookerQuery: lookerQuerySchema,
  position: widgetPositionSchema.optional().default({ row: 0, col: 0, width: 6, height: 4 }),
  config: z.record(z.unknown()).optional().default({}),
});

export type CreateWidget = z.infer<typeof createWidgetSchema>;

export const updateWidgetSchema = createWidgetSchema.partial();
export type UpdateWidget = z.infer<typeof updateWidgetSchema>;

export const runWidgetQuerySchema = z.object({
  model: z.string().min(1),
  explore: z.string().min(1),
  fields: z.array(z.string().min(1)).min(1),
  filters: z.record(z.string()).optional(),
  sorts: z.array(z.string()).optional(),
  limit: z.number().int().positive().max(5000).optional(),
});
